<template>
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">{{title()}}</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Enjoy more benefits when you upgrade your TRC Account!
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div v-if="$page.props.user.qualified_for_pf=='Yes'">
		<div class="shadow m-3 border border-default bg-white" :class="{'text-danger':!unimember.is_pf}">
			<div class="content">
				<h4 v-if="!unimember.is_pf" class="text-center">You are qualified to PLATINUM FAITHFUL upgrade</h4>
				<h4 v-if="unimember.is_pf" class="text-center"><p>Thank you for confirming your <span class="text-success">PLATINUM FAITHFUL</span> membership.</p></h4>
			</div>
		</div>
		<div v-if="!unimember.is_pf" class="content">
			<div class="row">
				<div class="col-12">
					<div class="block block-rounded shadow">
						<div class="block-content">
							<div class="h4 border-bottom py-1">PLATINUM FAITHFUL</div>
						</div>
						<div class="block-content small">
							<p>Give What You Want To Give From Your Heart</p>
							<div class="row">
								<div class="col-12">
									<div class="my-5 embed-responsive">
										<iframe class="embed-responsive-item" src="https://player.vimeo.com/video/522616960"
											frameborder="0"
											allow="autoplay; fullscreen; picture-in-picture"
											allowfullscreen
										></iframe>
									</div>
								</div>
							</div>
							<p>If you found this page, that means you’re very special to me.</p>
							<p>That means you’re a faithful Platinum Member that now has a lasting place in our Platinum family. May I propose something? Instead of you giving the usual Platinum Membership fee, just give what you want to give.</p>
							<p>I repeat what I said in my letter to you: I love you. I know that sounds so unprofessional and non-business-like, but I’m not afraid to show my feelings.</p>
							<p>After being together for years, our relationship is now permanent. So the exact fees no longer matter. Just give what you feel you want to give, based on (1) whatever blessings you receive from the Platinum Family, plus (2) how much you want to contribute to my mission and ministry work. (Note: You don’t even have to give anything. I love you unconditionally.)</p>
							<p>Note: This arrangement is NOT for everyone. Obviously, new people who want to join Platinum will have to give the usual membership fees. This is exclusively for you and our Platinum friends who have been faithfully with us for a number of years.</p>
							<p>To to this just click on the button below.</p>
							<p>Once again, I want you to know that our friendship has meant so much to me.</p>
							<p>Thank you for being God’s amazing blessing to my life.</p>
							<p>May you become Truly Rich,</p>
							<p>Bo Sanchez</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="content">

		<div v-if="flash && flash.title" class="alert alert-dismissible shadow m-3 border border-default bg-white" :class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'" role="alert">
			<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
			<p class="mb-0">
				{{ flash.message }}
			</p>
		</div>

		<div class="row">
			<div class="col-md-12">
				<div class="block block-rounded shadow">
					<div class="block-header text-center">
						<h3 class="block-title">CURRENT MEMBERSHIP</h3>
					</div>
					<div class="block-content bg-info-light text-center">
						<div class="h3 fw-bold mb-0">
							{{ unimember.rank }} {{ unimember.add_alias }}
						</div>
						<div v-if="!is_lifetime" class="fs-sm fw-semibold mb-3">
							Expiry: {{ unimember.expiry }}
						</div>
						<div class="fs-sm fw-semibold mb-3">
							{{unimember.membership_type}}
						</div>
					</div>

					<div v-if="selectedLifeTime">
						<BankAccountTemplate :data="selectedLifeTime" :member="unimember"/>					
					</div>

					<div v-if="!selectedLifeTime && !is_lifetime" class="block-content text-center">
						<div v-if="!['PLATINUM FAITHFUL'].includes(unimember.rank)">
							<inertia-link href="/member/advance-renew" class="btn btn-info"><i class="fa fa-arrow-circle-up me-2"></i>Advance Renew</inertia-link>
						</div>
					</div>
					<div v-if="!selectedLifeTime" class="block-content">
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter">
								<tbody>
									<tr>
										<th>Months Left</th>
										<td>{{ subscriptions.months_left }}</td>
									</tr>
									<tr>
										<th>Remaining Subscription</th>
										<td>&#8369;{{ form.rebates.string }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="form.rebates.int > 0" class="alert alert-success">
							<p class="mb-0">We have already deducted your remaining subscription to your new membership plan</p>
						</div>
					</div>

					<div v-if="!selectedLifeTime" class="block-content block-content-full block-content-sm">
						<div class="row">
							<div class="col-sm-6">
								
								<div class="form-group">
									<span class="text-danger fw-bold mx-1">*</span><label class="form-label">Membership</label>
								</div>
								<div
									v-for="(collections, index) in subscriptions.products"
									:key="index"
									class="block block-rounded"
								>
									<div class="block-header block-header-default">
										<h3 class="block-title">
											{{ index }}
											{{ collections[0].add_alias }}
										</h3>
									</div>
									<div class="block-content">
										<div class="row">
											<div
												class="col-12"
												v-for="subscription in collections"
												:key="subscription.prod_id"
											>
												<div class="form-check form-block mb-3">
													<input
														:checked="form.platf_term==subscription.prod_id"
														v-model="form.subscription"
														class="form-check-input"
														type="radio"
														:value="subscription.prod_id"
														:id="subscription.prod_id"
														name="subscription"
													/>
													<label class="form-check-label" :for="subscription.prod_id">
														<span class="d-flex align-items-center">
															<h6 class="fs-sm mb-0">
																{{ subscription.membership }}
															</h6>
															<span v-if="subscription.add_display" class="badge bg-warning ms-1">
																{{ subscription.add_display }}
															</span>
														</span>
														<small v-if="form.action!='pf_upgrade' && !unimember.is_pf">
															<span v-if="form.action === 'upgrade' && form.rebates.int > 0">
																<s class="text-muted">&#8369;{{ subscription.amount }}</s>
																<span class="ms-1 fs-sm fw-bold text-danger">&#8369;{{ subscription.less }}</span>
																<div v-if="subscription.add_desc!=null">
																	<div v-html="subscription.add_desc"></div>
																</div>
															</span>
															<span v-else>
																<small>
																	<s v-if="subscription.is_promo==1" class="me-1">&#8369;{{ subscription.regular_amount }}</s>
																	<span :class="{'fw-bold text-danger':subscription.is_promo==1}">&#8369;{{ subscription.amount }}</span>
																	<div v-if="subscription.add_desc!=null">
																		<div v-html="subscription.add_desc"></div>
																	</div>
																</small>
															</span>
														</small>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>	

							</div>

							<div class="col-sm-6">
								
								<div v-if="!unimember.is_pf && bank_available==false" class="block-content">
									<div class="row">
										<div class="col-xl-12">
											<div class="row">
												<div class="col-6">
													<div class="form-check form-block mb-4">
														<input
															v-model="form.payment_method"
															class="form-check-input"
															type="radio"
															:value="'CARD'"
															id="card"
															name="payment_method"
														/>
														<label class="form-check-label" for="card">
															<span
																class="d-flex align-items-center"
																style="
																	background-image: url(/media/logo/stripe-logo.png);
																	background-size: contain;
																	background-repeat: no-repeat;
																	background-position: center;
																	height: 100px;
																"
															>
															</span>
														</label>
													</div>
												</div>
												<div v-if="payment_available==true" class="col-6">
													<div class="form-check form-block mb-4">
														<input
															v-model="form.payment_method"
															class="form-check-input"
															type="radio"
															:value="'DRAGONPAY'"
															id="dragonpay"
															name="payment_method"
														/>
														<label class="form-check-label" for="dragonpay">
															<span
																class="d-flex align-items-center"
																style="
																	background-image: url(/media/logo/dragonpay.png);
																	background-size: contain;
																	background-repeat: no-repeat;
																	background-position: center;
																	height: 100px;
																"
															>
															</span>
														</label>
													</div>
												</div>
												<div v-if="payment_available==true" class="col-6">
													<div class="form-check form-block mb-4">
														<input
															v-model="form.payment_method"
															class="form-check-input"
															type="radio"
															:value="'DRAGONPAY-GCASH'"
															id="dragonpay_gcash"
															name="payment_method"
														/>
														<label class="form-check-label" for="dragonpay_gcash">
															<span
																class="d-flex align-items-center"
																style="
																	background-image: url(/media/logo/gcash.png);
																	background-size: contain;
																	background-repeat: no-repeat;
																	background-position: center;
																	height: 100px;
																"
															>
															</span>
														</label>
													</div>
												</div>
												<!-- <div class="col-4">
													<div class="form-check form-block mb-4">
														<input
															v-model="payment_method"
															class="form-check-input"
															type="radio"
															:value="'BROPAY'"
															id="bropay"
															name="payment_method"
														/>
														<label class="form-check-label" for="bropay">
															<span
																class="d-flex align-items-center"
																style="
																	background-image: url(/media/logo/bropay-logo.png);
																	background-size: contain;
																	background-repeat: no-repeat;
																	background-position: center;
																	height: 100px;
																"
															>
															</span>
														</label>
													</div>
												</div> -->
											</div>
										</div>
									</div>
								</div>

								<div v-if="form.action=='pf_upgrade' || unimember.is_pf" class="form-group">
									<div class="mb-4">
										<span class="text-danger fw-bold mx-1">*</span><label class="form-label" for="platf_amount">Any Amount (Minimum of &#8369;497.00)</label>
										<input
											v-model="form.platf_amount"
											:class="{ 'is-invalid': form.errors.platf_amount }"
											type="number"
											class="form-control"
											id="platf_amount"
											placeholder="Enter your amount"
											min="497"
										/>
										<div v-if="form.errors.platf_amount" class="invalid-feedback">
											<i class="fa fa-exclamation-circle"></i>
											{{ form.errors.platf_amount }}
										</div>
									</div>
								</div>

								<div v-if="form.payment_method == 'CARD'">
									<div v-if="unimember.has_card">
										<div class="form-check form-switch mb-4">
											<input
												v-model="form.use_existing_card"
												class="form-check-input"
												type="checkbox"
												:value="true"
												id="example-switch-default1"
												name="example-switch-default1"
											/>
											<label class="form-check-label form-label" for="example-switch-default1">
												Use existing card
											</label>
										</div>
										<div v-if="form.use_existing_card" class="mb-4">
											<p class="mb-0">
												<span class="fw-semibold">CARD: </span>
												<i>**** **** **** {{ unimember.card.last4 }}</i>
												<span class="badge bg-primary ms-2">{{ unimember.card.brand }}</span>
												<span>
													<button @click="deleteCCDetails" type="button" class="btn btn-xs btn-outline-danger ms-1" title="Delete My Credit Card Details"><i class="fa fa-trash"></i></button>
												</span>
											</p>
										</div>
									</div>
									<div v-if="!form.use_existing_card" class="form-group mb-4">
										<span class="text-danger fw-bold mx-1">*</span><label class="form-label">Card Information</label>
										<stripe @accept-token="acceptToken" ref="stripe" />
										<div v-if="form.errors.card" class="invalid-feedback d-block">
											<i class="fa fa-exclamation-circle"></i>
											{{ form.errors.card }}
										</div>
									</div>
								</div>

								<div v-if="bank_available==true" class="block block-rounded">
									<div class="block-content block-content-full">
										
			                			<p class="fw-bold">Do a fund transfer to the bank details below:</p>
			                			<table>
			                				<tbody>
			                					<tr>
			                						<td>Bank Name</td>
			                						<th class="ps-2">BDO Savings Account</th>
			                					</tr>
			                                    <tr>
			                                        <td>Account Number</td>
			                                        <th class="ps-2">00412-016-5097</th>
			                                    </tr>
			                                    <tr>
			                                        <td>Account Name</td>
			                                        <th class="ps-2">Bo Sanchez Inc.</th>
			                                    </tr>
			                				</tbody>
			                			</table>

			                			<div class="mt-4">
			                				<ul>
			                					<li class="mb-15">
			                						<h6>Instructions</h6>
			                						<div class="mt-30 mb-30">
			                							<ol>
			                								<li>Please email your proof of payment to <span class="text-info">support@trulyrichclub.com</span></li>
			                								<li>We will get back to you within 2-3 banking days.</li>
			                							</ol>
			                						</div>
			                					</li>
			                				</ul>
			                			</div>

									</div>
								</div>

								<div class="pb-4 text-end">
						
									<span class="float-start me-2">
										<button v-if="unimember.is_pf"
											@click="payLater"
											type="submit"
											class="btn btn-alt-info"
											:disabled="form.platf_amount<497"
										>
											<span v-if="form.processing">
												<div class="spinner-border spinner-border-sm text-dark" role="status" >
													<span class="sr-only mr-1">Please wait...</span>
												</div>
												<span class="mx-2">Please wait...</span>
											</span>
											<span v-else>
												<span>Pay Later</span>
											</span>
										</button>
									</span>
									<button
										@click="upgradeSubscription"
										type="submit"
										class="btn btn-alt-primary me-2"
										:disabled="
											(form.payment_method === 'CARD' && !form.use_existing_card && !form.token) ||
											form.processing || !form.subscription ||
											((form.action=='pf_upgrade' || unimember.is_pf) && form.platf_amount<497)
										"
									>
										<span v-if="form.processing">
											<div class="spinner-border spinner-border-sm text-dark" role="status" >
												<span class="sr-only mr-1">Please wait...</span>
											</div>
											<span class="mx-2">Please wait...</span>
										</span>
										<span v-else>
											<span v-if="form.action=='pf_upgrade' || unimember.is_pf">Give Now</span>
											<span v-else-if="bank_available==true">Proceed</span>
											<span v-else>Pay Now</span>
										</span>
									</button>

								</div>

							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<modal ref="deleteCreditCardModal">
			<template #title>Delete Credit Card Details</template>
			<template #body>
				<p class="text-danger fw-bold">Are you sure you want to delete your card details?</p>
				<p class="text-danger fw-bold">Your membership will not auto-renew and you might lose some of your benefits.</p>
			</template>
			<template #footer>
				<button @click="confirmDeleteCC" type="button" class="btn btn-alt-danger" :disabled="formCC.processing">
					<div
						v-if="formCC.processing"
						class="spinner-border spinner-border-sm text-dark me-1"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<i v-else class="fa fa-trash me-1"></i>
					<span>YES</span>
				</button>
				<button @click="deleteCreditCardModal.toggleModal" type="button" class="btn btn-alt-secondary">
					<i class="fa fa-times me-1"></i>NO
				</button>
			</template>
		</modal>

	</div>

</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../Layouts/AuthLayout';
import Stripe from '../../Shared/Components/Stripe';
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import { createToaster } from '@meforma/vue-toaster';
import BankAccountTemplate from '../BankAccountTemplate';

export default {
	layout: AuthLayout,
	props: {
		test 			: String,
		action 			: String,
		unimember 		: Object,
		is_lifetime 	: Boolean,
		subscriptions 	: Object,
		selectedLifeTime: Object,
		flash 			: Object,
		api_response 	: Object
	},
	components: { Stripe },
	// mounted(){
	// 	this.page = this.$page;
	// },
	setup(props) {

		const toast = createToaster();

		const payment_available = ref(true);
		const bank_available 	= ref(false);

		const deleteCreditCardModal = ref(null);

		const app_url 	= Ziggy.url;
		const modal 	= ref(null);
		const form 		= useForm({
							action 				: props.action,
							payment_method 		: 'CARD',
							pmethod 			: null,
							pchannel 			: null,
							subscription 		: props.unimember.is_pf ? props.unimember.platf_term : null,
							platf_term 			: props.unimember.platf_term,
							platf_amount 		: props.unimember.platf_amount,
							token 				: null,
							rebates 			: props.subscriptions.rebates,
							use_existing_card 	: props.unimember.has_card?true:false,
							test 				: props.test,
						});

		const formLifetime = useForm({
			payment_method 		: 'CARD',
			token 				: null,
			use_existing_card 	: props.unimember.has_card?true:false,
		});

		const title = () => {
						return {
							upgrade: 'Upgrade Membership',
							pf_upgrade: 'Avail Your Platinum Faithful',
						}[props.action]
					};


		const formCC = useForm({

		})

		const deleteCCDetails = ()=>{
			deleteCreditCardModal.value.toggleModal();
		}

		const confirmDeleteCC = ()=>{
			formCC.post(route('member.post.cc-details'),{
				preserveScroll: true,
				only:['flash,unimember,subscriptions'],
				onSuccess: ()=>{
					deleteCreditCardModal.value.toggleModal();
					form.use_existing_card = false;
				}
			})
		}

		const payLater = () => {
						form.post(route('member.post.renew-paylater'), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','api_response','unimember','subscriptions'],
							onSuccess: () => toggleModal
						})
					};

		const upgradeSubscription = () => {
						form.post(route('member.post.upgrade'), {
							// preserveState: true,
							// preserveScroll: true,
							// only: ['flash','unimember','subscriptions'],
							// onSuccess: () => toggleModal,
						})
					};

		const toggleModal = () => {
							modal.value.toggleModal()
						};

		const acceptToken = (token) => {
							form.token = token
						};

		watch(
			() => form.payment_method,
			(payment_method) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;	

				if(payment_method=='CARD' && props.unimember.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;

					if(payment_method=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M"))
			{
				form.payment_method = 'CARD';
				payment_available.value = false;
				bank_available.value 	= false;

				form.pmethod 			= null;
				form.pchannel 			= null;	

			}else
			{
				payment_available.value = true;

				if(value && val[0].includes("1200M"))
				{
					form.payment_method 	= 'BANK_TRANSFER';
					bank_available.value 	= true;
				}else
				{
					form.payment_method 	= 'CARD';
					bank_available.value 	= false;
					form.pmethod 			= null;
					form.pchannel 			= null;	
				}
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				if(value.result=="success")
				{
					toast.show("Successfully updated", { type: value.result});
				}else
				{
					toast.show("Failed to update", { type: "error"});
				}
			}
		})

		return {
			payment_available,
			bank_available,
			app_url,
			modal,
			deleteCreditCardModal,
			form,
			formCC,
			formLifetime,
			title,
			deleteCCDetails,
			confirmDeleteCC,
			payLater,
			upgradeSubscription,
			toggleModal,
			acceptToken,
		}
	},
}
</script>
